<template>
	<div class="page">
		<Tip :title="title" />
		<div class="tag">
			<span>{{tag}}</span>
		</div>
		<div class="from_div">
			<!--售后处理-->
			<el-form label-position="left">
				<el-form-item>
					<el-radio-group v-model="form.handle_type">
						<div class="col">
							<el-radio class="radio" label="1">同意寄回再退款</el-radio>
							<el-radio class="radio" label="2">同意不退货仅退款</el-radio>
							<div class="row">
								<el-radio class="style_" label="3">拒绝售后</el-radio>
								<el-input class="input" v-model="form.reject_reason" placeholder="请输入原因"></el-input>
							</div>
						</div>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submit">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {
		afterHandle,
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props: {
			type: Number
		},
		data() {
			return {
				title: '售后处理',
				tag: '对用户发起的售申请，先进行受理：',
				form: {
					handle_type: '1',
                    reject_reason: '',
				},
			}
		},
		mounted() {},
		methods: {
            submit() {
                if(this.form.handle_type == 3 && !this.form.reject_reason){
                    return this.$message({ type: 'error', message: '请填写拒绝的原因' });
                }

                this.form.after_sale_id = this.type;
                afterHandle(this.form).then(res => {
                    if (res.code == 0) {
                        this.$message({ type: 'success', message: res.msg || '操作成功!' });
                        this.$emit('close', 1)
                    }else{
                        console.log('submit error', params)
                        return this.$message({ type: 'error', message: res.msg });
                    }
                }).catch(err => {})
            },

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.tag {
		font-size: 14px;
		color: #000;
		padding-top: 20px;
	}

	.row {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.col {
		display: flex;
		flex-direction: column;
	}
	
	.radio{
		margin-bottom: 30px;
		font-size: 14px;
		color: #000;
	}
	
	.style_{
		font-size: 14px;
		color: #000;
	}
	
	.input{
		width: 235px;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		/* overflow: scroll; */
		/* height: 570px; */
		min-height: 100%;
		padding-bottom: 66px;
	}

	.select {
		width: 235px;
		margin-bottom: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>